import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import {  SeoService, } from '../../../../_services/index';
import { CommonService }  from '../../service/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'expediusa-shared-element-feature',
    templateUrl: './feature.component.html',
	styleUrls : ['./feature.component.css'],
	providers: [SeoService]
	
})

  
export class FeatureComponent implements OnInit, OnDestroy {

	/**This is used to prevent memory leaks **/
	private ngUnsubscribe: Subject<void> = new Subject<void>();
	/**This is used to prevent memory leaks **/

	env	=	environment;
    featureData : any = {};

	// Declare Constructor
	constructor(
		private commonService : CommonService, 
		private renderer:Renderer2) {}

	// Declare initialization
	ngOnInit(): void  {
		let scroll = 0;
		this.renderer.listen('window', 'scroll', (event:any) => {
			const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			if(verticalOffset>1 && !scroll){
				scroll = 1;
				/**This funcion used to get featured block after scroll*/
				this.getFeatureBlock();	
				/**This funcion used to get featured block after scroll*/
				event.preventDefault();
			}
		});
	}	
	/**This funcion used to get featured block*/
    public getFeatureBlock(){
		this.commonService.getFeatureBlocks().pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
            if (response.status === this.env.SUCCESS_STATUS) {
				this.featureData = response.result.feature_the_best;
			}
		});
	}
	/**This funcion used to get featured block*/

	/**This function are used for destroy the data**/
	ngOnDestroy(): void {
		this.ngUnsubscribe.next();
	}
	/**This function are used for destroy the data**/


}
